import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

export default function EbHinweisePanel({ ebHinweise }) {
  if (!ebHinweise) return null;

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        EB-Hinweise
      </Typography>
      <Alert severity="info" icon={<InfoIcon />}>
        {ebHinweise}
      </Alert>
    </Box>
  );
}
